import { useCallback, useState } from "react";
import { Flex } from "@chakra-ui/react";
import { ReceivedEmailMessageFilter } from "__generated__/gql/graphql";
import FilterBarWithSearch from "components/Shared/FilterEditor/FilterBar/FilterBarWithSearch";
import { useGraphileFiltersUrlQuery } from "components/Shared/FilterEditor/urlQuerySerializers";
import filterDefinitions from "components/Shared/EmailTable/filterDefinitions";
import { AppliedFilter } from "components/Shared/FilterEditor/utils";
import { useOnBrandChange } from "utils/routeParamHooks";
import BrandEmailAddressesModal from "./BrandEmailAddressesModal";
import EmptyStateModal from "./EmptyStateModal";
import Table, { TableProps } from "./Table";

const DEFAULT_FILTERS: AppliedFilter[] = [
  { filter: "isCompleted", variant: "equalTo", value: false },
];

type BrandEmailInboxProps = Omit<TableProps, "filter" | "onInitialIsEmpty">;

export default function BrandEmailInbox({ ...rest }: BrandEmailInboxProps) {
  const [isInitialTableEmpty, setIsInitialTableEmpty] = useState<
    boolean | undefined
  >();

  useOnBrandChange(() => {
    setIsInitialTableEmpty(undefined);
  });

  const { filter, filters, isTableReady, handleFiltersChange } =
    useGraphileFiltersUrlQuery<ReceivedEmailMessageFilter>(filterDefinitions, {
      defaultFilters: DEFAULT_FILTERS,
      externalQueryKeys: ["selectedEmailId"],
    });

  const handleInitialTableIsEmpty = useCallback((isEmpty: boolean) => {
    setIsInitialTableEmpty((existing) => existing ?? isEmpty);
  }, []);

  return (
    <>
      <FilterBarWithSearch
        key={String(isTableReady)}
        filterDefinitions={filterDefinitions}
        filters={filters}
        headerRight={
          <Flex alignItems="center" pr={4}>
            <BrandEmailAddressesModal />
          </Flex>
        }
        onFiltersChange={handleFiltersChange}
      />

      <Table
        {...rest}
        filter={filter}
        onInitialIsEmpty={handleInitialTableIsEmpty}
      />

      {isInitialTableEmpty && <EmptyStateModal />}
    </>
  );
}
